import { render } from "./404.vue?vue&type=template&id=a4f5425c&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=a4f5425c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f5425c"]])

export default __exports__